import axios from 'axios';

export  const HTTP = axios.create({
    withCredentials: true,
    crossdomain: true ,
    baseURL: 'http://sinistre.top-it.ma',
    //baseURL: 'http://localhost:8083',
});


export function getDemandes() {
  return HTTP.get('/demandes');
}
export function getEvents(id) {
  return HTTP.get('/events?id=' + id);
}

export function searchEvents(dto) {
  return HTTP.post('/search_events', dto);
}

export function getTypeEvents() {
  return HTTP.get('/type_events');
}


export function saveEvent(formEvent) {
  return HTTP.put('/saveEvent', formEvent);
}

export function getPersons(id) {
  return HTTP.get('/persons?id=' + id);
}
export function savePerson(formPerson) {
  return HTTP.put('/savePerson', formPerson);
}

export function personsSearch(formPerson) {
  return HTTP.post('/persons_search', formPerson);
}

export function getMapGarantieTypes() {
  return HTTP.get('/map_garantie_type_piece');
}

export function saveDemande(formDemande) {
  return HTTP.put('/saveDemande', formDemande);
}

export function demandeSearch(formPerson) {
  return HTTP.post('/demandes_search', formPerson);
}

export function getUsers(id) {
  return HTTP.get('/users?id=' + id);
}

export function saveUser(formUser) {
  return HTTP.put('/saveUser', formUser);
}

export function usersSearch(formUser) {
  return HTTP.post('/users_search', formUser);
}

export function lienParentes() {
  return HTTP.get('/lien_parentes');
}
export function categorieLienParentes() {
  return HTTP.get('/categorie_lien_parentes');
}
export function statusRevenus() {
  return HTTP.get('/status_revenus');
}
export function niveauScolaires() {
  return HTTP.get('/niveau_scolaires');
}
export function regions() {
  return HTTP.get('/regions');
}
export function provinces(regionId) {
  return HTTP.get('/provinces/' + regionId);
}
export function communes(provinceId) {
  return HTTP.get('/communes/' + provinceId);
}

export function downloadLetter(demandId) {
  return HTTP.post('/demande_lettre/', {id:demandId}, {responseType: 'blob'});
}

export function demandesExport(demandeSearchDto) {
  return HTTP.post('/demandes_export/', demandeSearchDto, {responseType: 'blob'});
}

export function typeIdentites() {
  return HTTP.get('/type_identites');
}

export function nationalities() {
  return HTTP.get('/nationalities');
}
